// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const GoogleIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Google/brand"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21.767 10.182h-9.534v3.864h5.488c-.512 2.454-2.651 3.863-5.488 3.863-3.35 0-6.047-2.636-6.047-5.909 0-3.273 2.698-5.91 6.047-5.91A6 6 0 0 1 16 7.41l2.977-2.91C17.163 2.955 14.837 2 12.233 2 6.558 2 2 6.455 2 12c0 5.546 4.558 10 10.233 10C17.349 22 22 18.364 22 12c0-.59-.093-1.227-.233-1.818Z"
}));
export default GoogleIcon;